export async function downloadFile(fileUrl, name) {
  // const response = await axios.get(fileUrl, { responseType: "blob" }); - Problem with CORS
  // const url = window.URL.createObjectURL(response.data);
  const url = fileUrl;
  const fileName = name || url.substring(url.lastIndexOf("/") + 1);
  const link = document.createElement("a");
  link.href = url;
  link.setAttribute("download", fileName);
  link.setAttribute("target", "_blank");
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  // URL.revokeObjectURL(url);
}

export function loadAsDataURL(file) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onloadend = () => {
      resolve(reader.result);
    };

    reader.onerror = error => {
      reject(error);
    };

    reader.readAsDataURL(file);
  });
}
